import Vue from 'vue';
import Vuex from 'vuex';
import general from '@shared/store/general/generalModule';
import systemHealth from '@shared/store/systemHealth/systemHealthModule';
import customer from '@shared/store/customer/customerModule';
import customerDetail from '@shared/store/customerDetail/customerDetailModule';
import deviceDetail from '@shared/store/deviceDetail/deviceDetailModule';
import comfortCredits from '@shared/store/comfortCredits/comfortCreditModule';
import snackbar from '@shared/store/snackbar/snackbarModule';
import providerPlan from '@shared/store/providerPlan/providerPlanModule';
import adoption from '@shared/store/adoption/adoptionModule';
import technician from '@shared/store/technician/technicianModule';
import promo from '@shared/store/promo/promoModule';
import order from '@shared/store/order/orderModule';
import service from '@shared/store/service/serviceModule';
import partnerSettings from '@shared/store/partnerSettings/partnerSettingsModule';
import setting from '@shared/store/setting/settingModule';
import serviceTitan from '@shared/store/serviceTitan/serviceTitanModule';
import partnerReview from '@shared/store/partnerReview/partnerReviewModule';
import userActivities from '@shared/store/userActivities/userActivitiesModule';
import leadDetail from '../../shared/store/leadDetail/leadDetailModule';
import partnerOrder from './modules/partnerOrder/partnerOrderModule';
import admin from '../../shared/store/admin/adminModule';
import partnerAgreement from '../../shared/store/partnerAgreement/partnerAgreementModule';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.CURRENT_ENV !== 'production',
  modules: {
    general,
    systemHealth,
    admin,
    customer,
    customerDetail,
    deviceDetail,
    partnerOrder,
    leadDetail,
    setting,
    comfortCredits,
    userActivities,
    snackbar,
    partnerReview,
    providerPlan,
    adoption,
    technician,
    promo,
    order,
    service,
    partnerSettings,
    partnerAgreement,
    serviceTitan,
  },
});
